import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    SilkIconWrapper,
    SilkIconWrapperNew,
    SilkIconWrapperNextRaces,
} from 'src/domains/sportsbook/webview/components/raceBoxSelection/RaceBoxSelection.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { LazyImage } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/LazyImage';
import {
    ImageDeviceSetType,
    ImageType,
} from 'src/domains/layouts/webview/components/common/lazyLoadingImage/common/ImagePictureHelpers.type';

interface LazyImageSilkPropsType {
    imgBase: ImageType;
    alt?: string;
    className?: string;
    imgDeviceSet?: ImageDeviceSetType;
    placeholder?: boolean;
}

export const LazyImageSilk = observer('LazyImageSilk', (props: LazyImageSilkPropsType) => {
    const { alt, imgBase, className, placeholder, imgDeviceSet } = props;

    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    if (imgBase.src === '') {
        if (configState.nextRacesNew) {
            return <SilkIconWrapperNextRaces />;
        }
        if (configState.raceSummaryRowHorseRacingNew) {
            return <SilkIconWrapperNew />;
        }
        return <SilkIconWrapper />;
    }

    return (
        <LazyImage
            alt={alt}
            imgBase={imgBase}
            className={className}
            placeholder={placeholder}
            imgDeviceSet={imgDeviceSet}
        />
    );
});
